import { isProduction } from '~/utils/env'

const development = {
  ACCOUNT_API: 'https://account-dev-us-central1-gifbernvka-uc.a.run.app',
  ADMIN_AUTHORIZATION_API: 'https://dev-dot-admin-dot-mwm-auth.appspot.com',
  ADMIN_REPORTS_API: 'https://reports-dev-europe-west1-uycgiclbca-ew.a.run.app',
  ADMIN_REVIEWS_API: 'https://api-dev-europe-west1-stiqrwpqqa-ew.a.run.app',
  ANALYTICS_API: 'https://analytics-dev-europe-west9-6xd26izywq-od.a.run.app',
  APP_API: 'https://dev.app.mwm-intranet.mwmwebapis.com',
  APP_MANAGEMENT_API: 'https://dev.management.mwm-business-manager.mwmwebapis.com',
  APP_USER_API: 'https://admin-dev-europe-west1-gifbernvka-ew.a.run.app',
  ASSET_MANAGER_API: 'https://dev-dot-api-dot-mwm-asset-manager.ew.r.appspot.com',
  AUTHENTICATION_API: 'https://dev-dot-user-dot-mwm-auth.appspot.com',
  AUTHORIZATION_API: 'https://dev-dot-authorization-dot-mwm-auth.appspot.com',
  BUILDS_API: 'https://build-dev-europe-west9-1058312231336.europe-west9.run.app',
  BUSINESS_INTELLIGENCE_API: 'https://api-dot-mwm-bi.ew.r.appspot.com',
  CATALYST_URL: 'https://catalyst.mwm.ai',
  CHECKLIST_API: 'https://dev-dot-checklist-dot-mwm-version.appspot.com',
  CLUSTERS_API: 'https://clusters-dev-europe-west1-hu4ui3wkoq-ew.a.run.app',
  DYNAMIC_SCREEN_API: 'https://dev-dot-management-dot-mwm-dynamic-screen.ey.r.appspot.com',
  EVENTS_API: 'https://event-dev-europe-west9-6xd26izywq-od.a.run.app',
  IAP_API: 'https://api-dev-europe-west2-45305736168.europe-west2.run.app',
  PROCOLOR_API: 'https://dev.admin.procolor-backend.mwmwebapis.com',
  RANKING_API: 'https://dev-dot-performance-squad-data-dot-mwm-intelligence.ew.r.appspot.com',
  SERVICES_API: 'https://dev-dot-services-dot-mwm-version.ew.r.appspot.com',
  STORAGE_API: 'https://dev-dot-files-dot-mwm-storage.appspot.com',
  STORAGE_API_V2: 'https://dev.files.mwm-storage.mwmwebapis.com',
  STORE_API: 'https://store-dev-europe-west1-molccirxma-ew.a.run.app',
  TODOLISTS_API: 'https://todolist-dev-europe-west9-6xd26izywq-od.a.run.app',
  TOOLBOX_API: 'https://toolbox-dev-europe-west9-6xd26izywq-od.a.run.app',
  UA_CAMPAIGN: 'https://mwm-ua-manager-intranet-dev-530307631011.europe-west1.run.app',
  VERSIONS_ADMIN: 'https://dev-dot-admin-dot-mwm-version.appspot.com',
  VERSIONS_API: 'https://dev-dot-api-dot-mwm-version.appspot.com',
}

const production = {
  ACCOUNT_API: 'https://account-prod-us-central1-gifbernvka-uc.a.run.app',
  ADMIN_AUTHORIZATION_API: 'https://admin-dot-mwm-auth.appspot.com',
  ADMIN_REPORTS_API: 'https://reports-prod-europe-west1-uycgiclbca-ew.a.run.app',
  ADMIN_REVIEWS_API: 'https://api-prod-europe-west1-stiqrwpqqa-ew.a.run.app',
  ANALYTICS_API: 'https://analytics-prod-europe-west9-6xd26izywq-od.a.run.app',
  APP_API: 'https://app-prod-europe-west9-1058312231336.europe-west9.run.app',
  APP_MANAGEMENT_API: 'https://prod.management.mwm-business-manager.mwmwebapis.com',
  APP_USER_API: 'https://admin-prod-europe-west1-gifbernvka-ew.a.run.app',
  ASSET_MANAGER_API: 'https://api-dot-mwm-asset-manager.ew.r.appspot.com',
  AUTHENTICATION_API: 'https://user-dot-mwm-auth.appspot.com',
  AUTHORIZATION_API: 'https://authorization-dot-mwm-auth.appspot.com',
  BUILDS_API: 'https://build-prod-europe-west9-1058312231336.europe-west9.run.app',
  BUSINESS_INTELLIGENCE_API: 'https://api-dot-mwm-bi.ew.r.appspot.com',
  CATALYST_URL: 'https://catalyst.mwm.ai',
  CHECKLIST_API: 'https://api-dot-checklist-dot-mwm-version.appspot.com',
  CLUSTERS_API: 'https://clusters-prod-europe-west1-hu4ui3wkoq-ew.a.run.app',
  DYNAMIC_SCREEN_API: 'https://management-dot-mwm-dynamic-screen.appspot.com',
  EVENTS_API: 'https://event-prod-europe-west9-6xd26izywq-od.a.run.app',
  IAP_API: 'https://api-prod-europe-west2-45305736168.europe-west2.run.app',
  PROCOLOR_API: 'https://prod.admin.procolor-backend.mwmwebapis.com',
  RANKING_API: 'https://performance-squad-data-dot-mwm-intelligence.ew.r.appspot.com',
  SERVICES_API: 'https://services-dot-mwm-version.ew.r.appspot.com',
  STORAGE_API: 'https://files-dot-mwm-storage.appspot.com',
  STORAGE_API_V2: 'https://prod.files.mwm-storage.mwmwebapis.com',
  STORE_API: 'https://store-prod-europe-west1-molccirxma-ew.a.run.app',
  TODOLISTS_API: 'https://todolist-prod-europe-west9-6xd26izywq-od.a.run.app',
  TOOLBOX_API: 'https://toolbox-prod-europe-west9-6xd26izywq-od.a.run.app',
  UA_CAMPAIGN: 'https://mwm-ua-manager-intranet-prod-530307631011.europe-west1.run.app',
  VERSIONS_ADMIN: 'https://admin-dot-mwm-version.appspot.com',
  VERSIONS_API: 'https://api-dot-mwm-version.appspot.com',
}

const config = isProduction() ? production : development

export default config
